import "../layouts/default"

import '../components/tabs';
import '../components/slider';
import '../components/rating';

import '../common/lightgallery';

const indexProductTabs = document.querySelector('.js-index-product-tabs')

if (indexProductTabs) {
    indexProductTabs.addEventListener('rTab.after.openTab', (event) => {
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                const slider = event.target.querySelector('r-slider')

                window.sliderLazyLoad.update()

                if (slider && slider.swiper) {
                    slider.swiper.update()

                    if (slider.swiper.params.cssMode) {
                        slider.swiper.wrapperEl.scrollTo(0, 0)
                    }
                }
            })
        })
    })
}
